import React from 'react'

import { Table } from '../'

import { AccountData } from './AccountData'

export const Accounts = ({ accountsNotConsolidatedInFull, onClick}) => (
  <Table
    columns={['Supplier', 'Balance', 'Instalment', 'Frequency', 'History']}
    rows={accountsNotConsolidatedInFull.map(account => (
      <tr
        onClick={() => onClick
          ? onClick(account)
          : null
        }
        key={`account_${account.id}`}>

        <AccountData
          creditReportSupplier={account.creditreportsupplier}
          balance={account.balance}
          instalment={account.instalment}
          paymentFreqDesc={account.paymentFreqDesc}
          paymentHistory={account.paymentHistory}
        />
      </tr>
    ))}
    objectRows={true}
    noCellPadding={true}
    className='slds-m-bottom_medium'
  />
)



// WEBPACK FOOTER //
// ./src/components/credit-application-credit-report/Accounts.js